import { PanelType } from '@/types/pulse';

/**
 * Every panel value that means "recruited through Respondent", for reading
 * rows and labelling them as one audience.
 *
 * Only PanelType.RESPONDENT is ever written to respondents.panel — the B2B/B2C
 * values belong to panel_campaigns (see the invariant on those enum members).
 * This list stays broad so a read or a label can't miss a row, not because a
 * respondent may hold one of the sub-panel values.
 */
export const RESPONDENT_PANEL_TYPES: number[] = [
  PanelType.RESPONDENT,
  PanelType.RESPONDENT_B2B,
  PanelType.RESPONDENT_B2C
];

/**
 * The panel value a respondent row may be stored under, collapsing the
 * campaign-only B2B/B2C values onto the generic RESPONDENT.
 *
 * Every write of respondents.panel goes through this, so a caller handing over a
 * campaign's panel lands on the person's existing row instead of splitting them
 * across a second one. Enforcement, not convenience: do not add a way to bypass
 * it.
 */
export function normalizeForRespondentPanel(panel: number): number {
  return panel === PanelType.RESPONDENT_B2B ||
    panel === PanelType.RESPONDENT_B2C
    ? PanelType.RESPONDENT
    : panel;
}
